import { render, staticRenderFns } from "./nutritionSaleForm.vue?vue&type=template&id=bbfd9f3a&scoped=true"
import script from "./nutritionSaleForm.vue?vue&type=script&lang=js"
export * from "./nutritionSaleForm.vue?vue&type=script&lang=js"
import style0 from "./nutritionSaleForm.vue?vue&type=style&index=0&id=bbfd9f3a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbfd9f3a",
  null
  
)

export default component.exports